import { render, staticRenderFns } from "./advants.vue?vue&type=template&id=fd4ef944&scoped=true"
import script from "./advants.vue?vue&type=script&lang=js"
export * from "./advants.vue?vue&type=script&lang=js"
import style0 from "./advants.vue?vue&type=style&index=0&id=fd4ef944&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4ef944",
  null
  
)

export default component.exports